module.exports = __webpack_public_path__ + "img/bald.2c7464b9.jpg";